import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { Groups, GroupSignatories } from '../../redux-store/types/api-types';
import { MobileViewDataRow, WebViewDataRow } from '../DataTable';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { isForeignEntity, isMSARFundType } from '../../utils/utilityFunctions';
import { MASTER_DESIGNATION } from '../../utils/constant';
import { formatShortDate } from '../../utils/date';

const headers = (fundType: string, investorType: string, ifXalt: boolean) => [
  {
    header: 'Name',
    label: 'name',
    valueGetter: (row: GroupSignatories) => row.name || 'N/A',
  },
  ...(isMSARFundType(fundType)
    ? [
        {
          header: 'Father Name',
          label: 'fatherName',
          valueGetter: (row: GroupSignatories) => row.fatherName || 'N/A',
        },
      ]
    : []),
  {
    header: isForeignEntity(investorType) ? 'Identification Number / PAN' : 'PAN',
    valueGetter: (row: GroupSignatories) => row.pan?.toUpperCase() || 'N/A',
  },
  ...(isMSARFundType(fundType)
    ? [
        {
          header: 'DIN / DPIN',
          valueGetter: (row: GroupSignatories) => row.dpin || 'N/A',
        },
      ]
    : []),
  {
    header: 'Email ID',
    valueGetter: (row: GroupSignatories) => row.email || 'N/A',
  },
  {
    header: 'Designation',
    valueGetter: (row: GroupSignatories) =>
      (ifXalt &&
      Object.keys(MASTER_DESIGNATION)
        .filter((item) => item != 'other')
        .includes(row.designation)
        ? MASTER_DESIGNATION[row.designation || '']
        : row.designation) || 'N/A',
  },
  {
    header: 'Mobile Number',
    valueGetter: (row: GroupSignatories) =>
      row.mobile && row.countryCode ? row.countryCode + '-' + row.mobile : row.mobile || 'N/A',
  },
  {
    header: 'Date of Birth',
    valueGetter: (row: GroupSignatories) => formatShortDate(row.dob) || 'N/A',
  },
  {
    header: 'Politically Exposed Person (PEP) Status',
    valueGetter: (row: GroupSignatories) => row.pepStatus || 'N/A',
  },
  ...(isMSARFundType(fundType)
    ? [
        {
          header: 'Address',
          valueGetter: (row: GroupSignatories) => row.completeAddress || 'N/A',
        },
      ]
    : []),
];

export default function AuthorizedSignatories({
  groups = [],
  ifXalt,
}: {
  groups: Groups[];
  ifXalt: boolean;
}): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const { scheme, applicants = [] } = application || {};
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography
              component="h2"
              sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
              Authorised Signatories
            </Typography>
            {groups.length === 0 && (
              <Grid
                xs={12}
                sm={12}
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: 'common.black',
                  textAlign: 'center',
                  my: 3,
                }}>
                No Authorised Signatories
              </Grid>
            )}
            {groups.map((group, index) => {
              return (
                <React.Fragment key={group.id}>
                  <Grid container pt={3}>
                    <Grid item xs={6}>
                      <Typography>{group.name}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography>
                        Total No. of required authorised signatories from this group:{' '}
                        {group.threshold}
                      </Typography>
                    </Grid>
                  </Grid>
                  {group?.groupsignatories?.map((signatory, ind) => {
                    return (
                      <Grid container pt={3} key={ind}>
                        <Grid xs={12} alignSelf="center">
                          <MobileViewDataRow
                            index={ind}
                            row={signatory}
                            tableHeader={headers(
                              scheme?.fundType || '',
                              applicants[0]?.investorType || '',
                              ifXalt
                            )}
                          />
                          {/* <WebViewDataRow
                        groupIndex={index}
                        tableData={group.groupsignatories.filter(
                          (_signatory) => _signatory.isActive
                        )}
                        tableHeader={headers}
                        renderAdditionalRow={false}
                        tableHeaderCustomStyles={{
                          '.MuiTableCell-head': {
                            fontFamily: 'Poppins, sans-serif',
                            fontSize: 14,
                            fontWeight: 500,
                            color: 'primary.main',
                          },
                        }}
                        rowCustomStyles={{
                          '.MuiTableCell-root': {
                            py: '8px',
                            overflowWrap: 'anywhere',
                            padding: { xs: '10px', sm: '30px' },
                          },
                        }}
                        tableBodyCustomStyles={{
                          '.MuiTableRow-root': {
                            '&:last-child': {
                              borderBottom: 'none',
                            },
                          },
                        }}
                      /> */}
                        </Grid>
                      </Grid>
                    );
                  })}
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
